import React, { Suspense, useEffect, useState } from 'react';
import _map from 'lodash/map';
import {
  StyledColumnHeaderCell,
  TableContainer,
} from 'components/Table';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Table from '@mui/material/Table';
import Paper from '@mui/material/Paper';
import { useAppDispatch, useAppState } from 'store/configureStore';
import { STRINGS } from 'config';
import { TableHeader } from 'components/UserTable/TableHeader';
import { DeleteUserModal } from 'components/UserTable/DeleteUserModal';
import { apiGetPracticeUserRoles, apiGetUsersFromCurrentPractice } from 'store/action/userManagement';
import { Feature, RenderOn } from '@econsult/econsult-ui/dist/components/FlagControlledFeature';
import { UserTableRow } from './TableRow';

const {
  USER_MANAGEMENT: { RESET_USER_DELETE_STATUS },
} = STRINGS.REDUCERS;
const { PRACTICE_USER_ROLES_ENABLED } = STRINGS.FEATURE_FLAGS;

export const UserTable = () => {
  const {
    app: { selectedPractice, selectedPracticeIsEhub, selectedPracticeHasAdminRights, user },
    userManagement: { usersInActivePracticeList },
    featureFlags,
  } = useAppState();
  const dispatch = useAppDispatch();
  const totalUsers = usersInActivePracticeList?.total;
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [showDeleteUserModal, setShowDeleteUserModal] = useState(false);
  const isPracticeUserRolesEnabled = featureFlags[PRACTICE_USER_ROLES_ENABLED];

  useEffect(() => {
    if (!selectedPracticeIsEhub) {
      if (selectedPractice) {
        apiGetUsersFromCurrentPractice(
          {
            practiceId: selectedPractice?.id,
            dispatch,
          },
        );

        if (isPracticeUserRolesEnabled) {
          apiGetPracticeUserRoles({ dispatch });
        }
      }
    }
    return () => {};
  }, [selectedPractice, selectedPracticeIsEhub, dispatch, isPracticeUserRolesEnabled]);

  const handleTableActionDeleteUser = email => {
    setShowDeleteUserModal(true);
    setSelectedEmail(email);
  };
  const handleOnCloseDeleteUserModal = () => {
    dispatch({ type: RESET_USER_DELETE_STATUS });
    setSelectedEmail(null);
    setShowDeleteUserModal(false);
  };

  return (
    <Suspense fallback={<p>Loading users...</p>}>
      <TableContainer id="SkipToUserListMainContent" data-automation="UserTableWrapper">
        {!selectedPracticeIsEhub && (
        <>
          <TableHeader
            totalUsers={totalUsers}
            dispatch={dispatch}
            selectedPracticeHasAdminRights={selectedPracticeHasAdminRights}
          />
          <TableContainer sx={{ border: 0, boxShadow: 0, mt: 2 }} component={Paper} data-automation="TableContainer">
            <Table aria-label="table">
              <TableHead>
                <TableRow data-automation="TableHeaderRow">
                  <StyledColumnHeaderCell data-automation="TableHeaderCellName">Name</StyledColumnHeaderCell>
                  <StyledColumnHeaderCell data-automation="TableHeaderCellEmail">Email</StyledColumnHeaderCell>
                  <Feature flags={[PRACTICE_USER_ROLES_ENABLED]}>
                    <RenderOn>
                      <StyledColumnHeaderCell data-automation="TableHeaderCellUserRole">Practice role</StyledColumnHeaderCell>
                    </RenderOn>
                  </Feature>
                  <StyledColumnHeaderCell data-automation="TableHeaderCellAdminRights">Admin rights</StyledColumnHeaderCell>
                  <StyledColumnHeaderCell sx={{ width: 50 }} data-automation="TableHeaderCellActions">Action</StyledColumnHeaderCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {_map(usersInActivePracticeList.users, row => (
                  <UserTableRow
                    key={row.email}
                    row={row}
                    onDeleteUser={handleTableActionDeleteUser}
                    currentUserEmail={user.currentUserEmail}
                    selectedPracticeHasAdminRights={selectedPracticeHasAdminRights}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
        )}
      </TableContainer>
      <DeleteUserModal
        selectedEmail={selectedEmail}
        isOpen={showDeleteUserModal}
        onClose={handleOnCloseDeleteUserModal}
      />
    </Suspense>
  );
};
